import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import { Theme } from '@routific/hive';

interface StaticDayProps extends PickersDayProps<any> {
  isSelected: boolean,
  isHovered: boolean,
  isBookend: boolean,
  hasRange: boolean,
}

const StaticDay: React.FC<StaticDayProps> = (props) => {
  const { isSelected, isHovered, hasRange, isBookend, className, day, ...other } = props;

  // PickersDay specific classes
  const pickerDayClassNames = [
    'HivePickersDay-root',
    isSelected && 'HivePickersDay-selected',
    isHovered && 'HivePickersDay-hovered',
    isBookend && 'HivePickersDay-bookend',
    hasRange && 'HivePickersDay-hasRange',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <PickersDay
      {...other}
      showDaysOutsideCurrentMonth={true}
      day={day}
      className={`${pickerDayClassNames} ${className || ''}`}
      sx={{
        '&.MuiPickersDay-root': {
          borderRadius: 2,
          fontSize: 16,
          margin: '0px',
          transition: 'background-color .1s ease-in-out',
        },
        '&.MuiPickersDay-root:not(.MuiPickersDay-dayOutsideMonth):not(.HivePickersDay-bookend)': {
          '&.Mui-selected': {
            backgroundColor: Theme.Colors.primary4,
            color: Theme.Colors.gray0,
          },
          '&:hover': {
            backgroundColor: Theme.Colors.primary5,
            color: Theme.Colors.gray0,
          },
        },
        '&.MuiPickersDay-dayOutsideMonth': {
          color: Theme.Colors.textInvalid,
        },
        '&.Mui-disabled': {
          cursor: 'not-allowed',
        },
        '&.HivePickersDay-selected:not(.HivePickersDay-bookend):not(.HivePickersDay-hasRange), &.HivePickersDay-bookend':
        {
          '&:not(.Mui-disabled)': {
            backgroundColor: Theme.Colors.primary5,
            color: Theme.Colors.gray0,
          },
        },
        '&.HivePickersDay-selected:not(.HivePickersDay-bookend).HivePickersDay-hasRange':
        {
          '&:not(.Mui-disabled)': {
            backgroundColor: Theme.Colors.primary4,
            color: Theme.Colors.gray0,
          },
        },
        '&:hovered:not(.Mui-selected)':
        {
          borderColor: Theme.Colors.primary5,
          borderWidth: 1,
          borderStyle: 'solid',
          backgroundColor: 'transparent',
        },
        '&.MuiPickersDay-today':
        {
          borderColor: Theme.Colors.primary5,
        },
      }}
      data-testid={'static-day'}
    >
      {day.toLocaleString({ day: '2-digit' })}
    </PickersDay>
  );
};

export default StaticDay;
